/**
 * Launch flags for features that are built but not yet switched on.
 *
 * These exist so a feature can be hidden without deleting its code. Anything
 * gated here should be reachable again by flipping a single value, not by
 * restoring a deleted screen.
 */

/**
 * Services and jobs are not part of the first launch. While this is false the
 * onboarding step that sets them up is hidden, and finishing onboarding does
 * not wait on it. Flip to true when they ship.
 */
export const TRADING_ONBOARDING_ENABLED = false;

/**
 * Signing up and signing in with a phone number instead of an email. While this
 * is false the email/phone choice is hidden and email is the only method. The
 * mobile number is still collected at signup either way, as a contact detail.
 */
export const PHONE_AUTH_ENABLED = false;
